<template>
  <div>
    <px-view-header title="Locais de entrega" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-listagem-locais-entrega-header :on-click-refresh="onClickRefresh"
                                       :on-change-filter="onChangeFilter"
                                       @change="onChangeFilter"/>
    <px-lista-locais-entrega :locais-entrega="locaisEntrega"
                             :loading="loading"
                             :on-change-options="onChangeOptions"
                             :options-list="optionsList"
                             :footer-options="footerOptions"
                             @remove="onRemove"
                             @update="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-locais-entrega/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ListagemLocaisEntregaHeader from './ListagemLocaisEntregaHeader.vue';
import ListaLocaisEntrega from './ListaLocaisEntrega.vue';
import LocaisEntregaService from './locais-entrega-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Locais de entrega' },
      ],
      locaisEntrega: {
        content: [],
        total: 0,
      },
      loading: false,
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemLocaisEntrega', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemLocaisEntrega', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.resetPage();
      this.getLocaisEntrega();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getLocaisEntrega();
    },
    onClickRefresh() {
      this.getLocaisEntrega();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getLocaisEntrega() {
      this.loading = true;

      this.updateFilter(this.stringFilter);

      const { limit, offset } = this.listOptions;
      return LocaisEntregaService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.locaisEntrega = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    onRemove(localEntrega) {
      this.loading = true;
      return LocaisEntregaService.remove(localEntrega.id)
        .then(() => {
          this.$toast('Local de entrega removido', { color: 'success' });
          return this.getLocaisEntrega();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
  },
  components: {
    pxListagemLocaisEntregaHeader: ListagemLocaisEntregaHeader,
    pxListaLocaisEntrega: ListaLocaisEntrega,
  },
};
</script>
